import type { ComponentType } from 'react';
import { InboxIcon } from '@heroicons/react/24/outline';

interface EmptyStateProps {
  text?: string;
  icon?: ComponentType<{ className?: string }>;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  text = 'No data',
  icon: Icon = InboxIcon,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="mx-auto w-full max-w-[180px] flex flex-col items-center justify-center py-12 text-muted">
      <Icon className="w-10 h-10 mb-3 opacity-50" />
      <p className="text-sm text-center leading-snug">{text}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 px-3 py-1.5 rounded-lg text-sm font-medium bg-primary/15 text-primary hover:bg-primary/25 transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}